import { type VariantProps, cva } from "class-variance-authority";
import * as React from "react";
import { cx } from "../internal/cx.js";

const fieldGridVariants = cva("cw-v2-field-grid", {
  variants: {
    variant: {
      stack: "cw-v2-field-grid--stack",
      twoColumn: "cw-v2-field-grid--two-column",
      threeColumnCompact: "cw-v2-field-grid--three-column-compact",
    },
  },
  defaultVariants: {
    variant: "stack",
  },
});

export type FieldGridVariant = NonNullable<VariantProps<typeof fieldGridVariants>["variant"]>;

export interface FieldGridProps
  extends React.HTMLAttributes<HTMLDivElement>,
    VariantProps<typeof fieldGridVariants> {}

/**
 * Shared layout for controlled form fields inside cards/forms. Variants:
 * `stack` (single-column rhythm for registration/auth), `twoColumn`
 * (responsive two-column), `threeColumnCompact` (fixed three-column row
 * for split inputs like DOB).
 */
export const FieldGrid = React.forwardRef<HTMLDivElement, FieldGridProps>(function FieldGrid(
  { className, variant, ...props },
  ref,
) {
  return <div ref={ref} className={cx(fieldGridVariants({ variant }), className)} {...props} />;
});
FieldGrid.displayName = "FieldGrid";
